// Korean input rules (design 8.7).
//
// PC (fine pointer): Enter sends, Shift+Enter is a new line.
// Phone (coarse pointer): Enter is a new line; only the send button sends.
// Never send while a syllable is being composed: React's synthetic event has
// no isComposing, so check the native event and the legacy keyCode 229.

export interface KeyLike {
  key: string
  shiftKey: boolean
  nativeEvent: { isComposing?: boolean }
  keyCode?: number
}

export function isComposing(e: KeyLike): boolean {
  return e.nativeEvent.isComposing === true || e.keyCode === 229
}

/** True when this Enter key press should send the message. */
export function enterSends(e: KeyLike, finePointer: boolean): boolean {
  if (e.key !== 'Enter' || isComposing(e)) return false
  return finePointer && !e.shiftKey
}

/** Ends the composition of a syllable in el now (design 8.7). The send
    buttons keep the focus in the box (the keyboard stays open), so nothing
    else ends it: the sent text would stay in the box until the next key,
    which would go on composing it ("안녕하" + "ㄱ"). The focus leaves and
    comes back at once: the browser puts the syllable in (compositionend)
    and the keyboard starts anew. */
export function endComposition(el: HTMLTextAreaElement | HTMLInputElement | null): void {
  if (!el || el.ownerDocument.activeElement !== el) return
  el.blur()
  el.focus()
}

export function hasFinePointer(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(pointer: fine)').matches
}

/** A touch screen is the main pointer (a phone): the camera is offered. */
export function hasCoarsePointer(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(pointer: coarse)').matches
}
